import { AltRouteOutlined } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { IRideDto } from "@ryde/shared";

import { RideBottomBlockStyled } from "../ride.styled";

export interface IRideHadDetourIndicatorProps {
  rideDto?: Partial<IRideDto>;
}

export const RideHadDetourIndicator: FC<IRideHadDetourIndicatorProps> = ({
  rideDto,
}) => {
  const { t } = useTranslation();

  // History badge: shown once the vehicle is back on the course (the live RideDetourIndicator covers the active state).
  if (
    rideDto?.metadata?.hadDetour !== true ||
    rideDto?.metadata?.inDetour === true
  ) {
    return null;
  }

  return (
    <RideBottomBlockStyled className="ride-had-detour-indicator">
      <FramerTooltip
        content={t("ride.INDICATORS.hadDetourTooltip")}
        rtlStrippedBottomLeftPlacement
      >
        <span>
          {/* Outlined variant (vs the filled AltRoute on the live RideDetourIndicator) marks this as the historical badge. */}
          <AltRouteOutlined className="ride-indicators__had-detour" />
        </span>
      </FramerTooltip>
    </RideBottomBlockStyled>
  );
};
